export class whatsapplogResponse{
    companyId:number
    companyName:string
    contactNo:string
    generatedAt:any
    logId:number
    MINUTE:any
    moduleId:number
    moduleName:number    
    msgcount:number
    projectName:string   
    templateName:string
    constructor(
        companyId:number,
        companyName:string,
        contactNo:string,
        generatedAt:any,
        logId:number,
        MINUTE:any,
        moduleId:number,
        moduleName:number,  
        msgcount:number,
        projectName:string,   
        templateName:string
    ){
this.companyId=companyId;
this.companyName=companyName;
this.contactNo=contactNo;
this.generatedAt=generatedAt;
this.logId=logId;
this.MINUTE=MINUTE;
this.moduleId=moduleId;
this.moduleName=moduleName;
this.msgcount=msgcount;
this.projectName=projectName;
this.templateName=templateName;
    }
}